import { BellFilled, EyeFilled } from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
  message,
} from "antd";
import { CALL_API } from "common/API";
import COLORS from "common/Colors";
import { LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { concat, includes, orderBy, reduce } from "lodash";
import AllStaffLeaveBalance from "molecules/AllStaffLeaveBalance";
import AttendanceBarChart from "molecules/AttendanceBarChart";
import LeaveDonutChart from "molecules/LeaveDonutChart";
import LocationBasedPresentStaff from "molecules/LocationBasedPresentStaff";
import moment from "moment";
import LeaveFormModel from "organisms/LeaveFormModel";
import ViewMore from "organisms/ViewMore";
import { useEffect, useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { getMySqlDate } from "utils/Date";
import Filter from "../assets/Filter.svg";
import Icon from "atoms/Icon";
import { CheckCircleFilled } from "@ant-design/icons";
import axios from "axios";

const StyledRow = styled(Row)`
  padding-top: 20px;
`;

const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;

  &:hover {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const StyledLeaveRow = styled(Row)`
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px;
  height: 100%;
  margin: 20px;
  @media (max-width: 417px) {
    display: block !important;
    padding-bottom: 10px;
    .leavereportstyle {
      margin-left: 70px;
    }
  }
`;

const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin-top: 20px;
  .chartstyle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  @media (max-width: 410px) {
    .chartstyle {
      display: block;
      align-items: left !important;
    }
  }
`;

const StyledForm = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .select {
    width: 150px;
  }
  @media (max-width: 410px) {
    margin-top: 5px;
    justify-content: flex-start;
    align-items: left !important;
  }
`;

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #141414;
  margin-right: auto;
`;
const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
    border: none !important;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

function HrDashboard({
  ClientId,
  selectedDepartmentId,
  userRoleId,
  departmentList,
  roleList,
  AllDepartmentList,
  Menulist,
  leaveCategoryList,
  userList,
  updateSuccessModal,
  leaveList,
  setLeaveList,
  type,
}) {
  console.log("departmentList-->", departmentList);
  const [leaveCatgeory, setLeaveCatgeory] = useState([]);
  const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
  const [displayLeaveModal, toggleDisplayLeaveModal] = useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [leaveID, setLeaveID] = useState();
  const [havingCancel, sethavingCancel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [leaveSummary, setLeaveSummary] = useState({});
  const [myLeaveSummary, setMyLeaveSummary] = useState({});
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [staffDepartmentLeaveModal, toggleStaffDepartmentLeaveModal] =
    useState(false);
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [userLeaves, setUserLeaves] = useState([]);
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);
  const [allLeaveConsumed, setAllLeaveConsumed] = useState();
  const [totalDepartmentLeave, setTtlDepartmentLeave] = useState();
  console.log("totalDepartmentLeave-->", totalDepartmentLeave);
  const [availableLeaves, setAvailableLeaves] = useState([]);
  const [leavedataBasedonLeaveId, setLeaveDataBasedonLeaveId] = useState({});
  const csvLinkDepartment = useRef();
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const allActiveUserData = {};
  let overAllAvailableLeave = {};
  let overAllConsumedLeave = {};

  // const getAvailableLeaves = async () => {
  //   try {
  //     const { code, response } = await CALL_API(`employee/node_leave`, "post", {
  //       clientid: ClientId,
  //     });
  //     if (code === STATUS_CODE.SUCCESS) {
  //       setAvailableLeaves(response);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  useEffect(() => {
    getAllDepartmentTotalLeavetWise();
    getLeaveList();
    getLeaveListCategories();
    // getAvailableLeaves();
  }, []);
  useEffect(() => {
    // Guard clause: Ensure required data is available before execution
    if (!leaveCategoryList?.length || !userList?.length) {
      return;
    }

    let leaveStatistics = {};
    let newLeaveStatistics = {};
    let overAllAvailableLeave = {}; // Initialize the object
    let overAllConsumedLeave = {}; // Initialize the object
    let allActiveUserData = {};
    let overAllCarryforwardLeave = {}; // Initialize the object

    // Iterate over leave categories
    leaveCategoryList.forEach((category) => {
      const categoryId = category.leave_category_id;
      let availableCount = 0;
      let consumedCount = 0;
      let carryforwardCount = 0;
      // allLeaveConsumed?.response.forEach((categoryDetails) => {
      //   // const availableItems =
      //   //   categoryDetails?.leavecategoryid === categoryId ?.[categoryId]?.available || [];
      //   const consumedItems =
      //     categoryDetails?.leaveCategoryDetails?.[categoryId]?.consumed || [];

      //   if (consumedItems.length) {
      //     userList.forEach((user) => {
      //       // const filteredAvailableItems = availableItems.filter(
      //       //   (item) => user.userid === item.userid
      //       // );
      //       const filteredConsumedItems = consumedItems.filter(
      //         (item) => user.userid === item.userid && item.status_id === "5"
      //       );

      //       if (filteredConsumedItems.length) {
      //         if (!allActiveUserData[categoryId]) {
      //           allActiveUserData[categoryId] = { available: [], consumed: [] };
      //         }
      //         // allActiveUserData[categoryId].available.push(
      //         //   ...filteredAvailableItems
      //         // );
      //         allActiveUserData[categoryId].consumed.push(
      //           ...filteredConsumedItems
      //         );
      //       }
      //     });
      //   }
      // });
      leaveCatgeory?.forEach((categoryDetails) => {
        if (categoryDetails?.categoryid === categoryId) {
          userList
            // ?.filter((val) => val?.status_id === "1")
            ?.forEach((user) => {
              if (
                categoryDetails?.userid === user.userid
                // &&
                // category?.locationId?.includes(user?.baselocationid)
              ) {
                if (!allActiveUserData[categoryId]) {
                  allActiveUserData[categoryId] = {
                    available: [],
                    consumed: [],
                  };
                }
                allActiveUserData[categoryId].available.push(categoryDetails);
              }
            });
        }
      });

      console.log("allActiveUserData-->", allActiveUserData);

      // Calculate available leaves
      allActiveUserData[categoryId]?.available?.forEach((user) => {
        const userGender = user.gender?.toLowerCase();
        const eligibleGender = category.eligible?.toLowerCase();
        if (
          user.categoryid === categoryId &&
          (userGender === eligibleGender || eligibleGender === "both")
        ) {
          availableCount += parseFloat(user.available) || 0;
          consumedCount += parseFloat(user.consumed) || 0;
          carryforwardCount += parseFloat(user.carry_forward) || 0;
        }
      });

      // Calculate consumed leaves
      // allActiveUserData[categoryId]?.consumed?.forEach((user) => {
      //   const userGender = user.gender?.toLowerCase();
      //   const eligibleGender = category.eligible?.toLowerCase();
      //   if (
      //     user.categoryid === categoryId &&
      //     (userGender === eligibleGender || eligibleGender === "both")
      //   ) {
      //     consumedCount += parseFloat(user.consumed) || 0;
      //   }
      // });
      setLeaveDataBasedonLeaveId(allActiveUserData);
      console.log("allActiveUserData12-->", allActiveUserData);

      // Store overall leave calculations
      overAllAvailableLeave[categoryId] = availableCount;
      overAllConsumedLeave[categoryId] = consumedCount;
      overAllCarryforwardLeave[categoryId] = carryforwardCount;
    });

    console.log("overAllAvailableLeave-->", overAllAvailableLeave);

    // Initialize leaveStatistics
    leaveCategoryList.forEach((category) => {
      leaveStatistics[category.leave_category_name] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
      };
    });

    // Initialize newLeaveStatistics
    leaveCategoryList.forEach((category) => {
      newLeaveStatistics[category.leave_category_id] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
      };
    });

    // Ensure `leaveCatgeory` exists before filtering
    // const approvedLeaves =
    //   leaveCatgeory?.filter((item) => item.status_id === "5") || [];

    // approvedLeaves.forEach((leave) => {
    //   const leaveCategoryName = leave.leave_category_name;
    //   if (leaveStatistics[leaveCategoryName]) {
    //     leaveStatistics[leaveCategoryName].consumed +=
    //       parseFloat(leave.number_of_days) || 0;
    //   }
    // });

    // Map updated leave data
    const updatedLeaveData = leaveCategoryList.map((category) => {
      const categoryName = category.leave_category_name;
      const categoryId = category.leave_category_id;

      // const userCount = userList.filter((user) => {
      //   const eligibleGender = category.eligible?.toLowerCase();
      //   return (
      //     eligibleGender === "both" ||
      //     eligibleGender === user.gender?.toLowerCase()
      //   );
      // }).length;

      return {
        categoryName,
        id: categoryId,
        data: [
          {
            type: "available",
            value: overAllAvailableLeave[categoryId] || 0,
            carryforward: overAllCarryforwardLeave[categoryId] || 0,
          },
          { type: "consumed", value: overAllConsumedLeave[categoryId] || 0 },
        ],
      };
    });

    setLeaveSummary(updatedLeaveData);
    setUserLeaves(updatedLeaveData);
  }, [leaveCatgeory, userList, leaveCategoryList, allLeaveConsumed]);

  const openDetailWindow = (name, id) => {
    setSelectedLeaveTypeId(id);
    setSelectedLeaveType(`Department's ${name} Balance`);
    setTtlDepartmentLeave(leavedataBasedonLeaveId[id]?.available);

    toggleStaffDepartmentLeaveModal(true);
  };

  // useEffect(() => {
  //   if (selectedLeaveTypeId) {
  //     getAllDepartmentWiseData();
  //   }
  // }, [selectedLeaveTypeId]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const ApproveOk = async (reason) => {
    return new Promise(async (resolve) => {
      await approveRejectCancelLeave2(5, reason, havingCancel);
      resolve();
    }).catch((err) => console.log("[ApproveOk] Error-->", err));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setLoading(true);
    ApproveOk();
  };

  const getLeaveList = async () => {
    return new Promise(async (resolve, reject) => {
      setLeaveList([]);

      if (selectedDepartmentId) {
        setDisplayTaskLoader(true);
        const { code, leaves = [] } = await CALL_API(
          `leave-list/${ClientId}`,
          "post",
          {
            status_id: "4",
            department_id: [""],
            start_date: dates.startDate,
            end_date: dates.endDate,
          },
        );

        setDisplayTaskLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveList(leaves.reverse());

          resolve(leaves);
        } else {
          reject([]);
        }
      } else {
        reject();
      }
    });
  };
  const getLeaveListCategories = async () => {
    return new Promise(async (resolve, reject) => {
      setLeaveCatgeory([]);

      if (selectedDepartmentId) {
        // toggleLeaveReportLoader(true);
        const { code, leaves = [] } = await CALL_API(
          `employee/allleave`,
          "post",
          {
            clientid: ClientId,
            year: new Date().getFullYear().toString(),
            reportingmanager: "",
            userid: [],
          },
        );
        setLeaveCatgeory(leaves);

        resolve(leaves);
        // toggleLeaveReportLoader(false);
        // if (
        //   includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        // ) {
        //   setLeaveCatgeory(response);

        //   resolve(response);
        // } else {
        //   reject([]);
        // }
      } else {
        reject([]);
      }
    });
  };

  const headers = {
    Tymeplusjwt: window.localStorage.getItem("token") || "",
  };

  /****************************************************************************************************/

  const getAllDepartmentTotalLeavetWise = async () => {
    toggleLeaveReportLoader(true);
    const api =
      "https://csdtvnjanj.execute-api.ap-southeast-2.amazonaws.com/Prod/leave-service/";
    const currentYear = new Date().getFullYear().toString();
    const obj = {
      method: "overallTotalLeavesAvailableAndConsumed",
      parameters: {
        year: currentYear,
        departmentId: [""],
      },
    };

    try {
      const response = await axios.post(`${api}${ClientId}`, obj, {
        headers: headers,
      });
      if (response.data.status === "SUCCESS") {
        setAllLeaveConsumed(response.data);
        toggleLeaveReportLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      toggleLeaveReportLoader(false);
    }
  };

  // const getAllDepartmentWiseData = async () => {
  //   const api =
  //     "https://csdtvnjanj.execute-api.ap-southeast-2.amazonaws.com/Prod/leave-service/";
  //   const obj = {
  //     method: "userWiseOverallTotalLeavesAvailableAndConsumed",
  //     parameters: {
  //       leave_type: selectedLeaveTypeId,
  //       year: `${new Date().getFullYear()}`,
  //     },
  //   };

  //   try {
  //     const response = await axios.post(`${api}${ClientId}`, obj, {
  //       headers: headers,
  //     });
  //     setTtlDepartmentLeave(response?.data?.response);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const storeUserData = [];
  useEffect(() => {
    let departmentStatistics = {};

    // 1️⃣ Initialize each department
    AllDepartmentList?.forEach((dept) => {
      departmentStatistics[dept.department_id] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
        items: [],
      };
    });

    // 2️⃣ Sum values from totalDepartmentLeave
    totalDepartmentLeave?.forEach((item) => {
      const deptId = Number(item.basedepartmentid);

      if (departmentStatistics[deptId]) {
        departmentStatistics[deptId].items.push(item);
        departmentStatistics[deptId].available += Number(item.available || 0);
        departmentStatistics[deptId].consumed += Number(item.consumed || 0);
        departmentStatistics[deptId].carryforward += Number(
          item.carry_forward || 0,
        );
      }
    });

    console.log("departmentStatistics →", departmentStatistics);

    // 3️⃣ Build final formatted output (same style as your example)
    const updatedData = AllDepartmentList.map((dept) => {
      const departmentId = dept.department_id;
      const departmentName = dept.department_name;

      return {
        categoryName: departmentName,
        categoryid: departmentId,
        items: departmentStatistics[departmentId]?.items,
        data: [
          {
            type: "available",
            value: departmentStatistics[departmentId]?.available || 0,
            carryforward: departmentStatistics[departmentId]?.carryforward || 0,
          },
          {
            type: "consumed",
            value: departmentStatistics[departmentId]?.consumed || 0,
          },
        ],
      };
    });

    console.log("updatedDepartmentData →", updatedData);

    setAvailableLeaves(updatedData);
  }, [AllDepartmentList, totalDepartmentLeave]);

  // totalDepartmentLeave?.forEach((user) => {
  //   const consumedData = totalDepartmentLeave?.consumed?.find(
  //     (itm) => itm?.user_id === user?.user_id
  //   );
  //   const matchedUser = userList?.find((item) => item.userid === user.user_id);
  //   if (matchedUser) {
  //     storeUserData.push({
  //       userID: user.user_id,
  //       genter: user.gender,
  //       userdepartmentid: matchedUser?.basedepartmentid,
  //       available: user.total_leaves,
  //       consume: consumedData ? consumedData?.leaves_consumed : 0,
  //     });
  //   }
  // });

  /*******************************************************************************************************/

  const approveRejectCancelLeave2 = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request,
  ) => {
    return new Promise(async (resolve) => {
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          userid: leaveDetails?.userid,
          departmentId: selectedDepartmentId,
          user_leave_id: leaveID,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        },
      );

      if (code === STATUS_CODE.SUCCESS) {
        setLoading(false);
        setIsModalOpen(false);
        // message.success(`Leave has been approved`);
        updateSuccessModal({
          visibility: true,
          message: "Approved",
          Sucessicon: (
            <div className="d-flex justify-content-center align-itemw-center">
              <CheckCircleFilled style={{ color: "green" }} />
            </div>
          ),
        });
        getLeaveList();
      } else {
        message.error(`Something went wrong. Please try again.`);
      }
      resolve();
    });
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 10,
    showSizeChanger: false,
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
    },

    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Start Date - Day",
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          const dateFormat = moment(record.start_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.start_date).format("dddd");
          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_start_date).format(
            "DD MMM YYYY",
          );
          const getdayAlone = moment(record.new_start_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },

    {
      title: "End Date - Day",
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          const dateFormat = moment(record.end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.new_end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },
    {
      title: "Days",
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "7%",
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "" ||
          record.new_number_of_days === "null"
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
     {
      title: "Reliever Name",
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Leave Type",
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },
    {
      title: "Amended Leave",
      dataIndex: "having_cancel_request",
      key: "having_cancel_request",
      width: "10%",

      render: (having_cancel_request) => {
        if (having_cancel_request === "1") {
          return "Yes";
        } else {
          return "No";
        }
      },
    },
    {
      title: "Applied On",
      dataIndex: "created_at",
      key: "created_at",
      width: "10%",
      render: (_, record) => {
        const dateFormat = moment(record.created_at).format("DD MMM YYYY");

        return `${dateFormat}`;
      },
    },
  ];

  // if (
  //   Menulist?.find(
  //     (item) =>
  //       item?.key === "allapprovals" &&
  //       item?.subMenu?.find(
  //         (subItem) => subItem?.key === "approvals" && subItem?.permission.edit
  //       )
  //   )
  // ) {
  //   columns.push({
  //     title: "Action",
  //     dataIndex: "address",
  //     key: "address",
  //     width: "10%",
  //     render: (_, record) => (
  //       <>
  //         <Tooltip title="View Leave">
  //           <EyeFilled
  //             className="action-button"
  //             onClick={() => viewLeave(record, true)}
  //           />
  //         </Tooltip>
  //         {(userRoleId === 1 || userRoleId === 6) && (
  //           <Tooltip title="Remind HOD & Assistant HOD" placement="left">
  //             <BellFilled
  //               className="action-button"
  //               onClick={() => remindSuperior(record)}
  //             />
  //           </Tooltip>
  //         )}
  //       </>
  //     ),
  //   });
  // }

  const departmentOptions = concat(
    orderBy(AllDepartmentList, [(val) => val.department_id], ["asc"]).map(
      (dept) => ({
        value: dept.department_id,
        label: dept.department_name,
      }),
    ),
  );

  const filterleavereport = selectedDepartment
    ? leaveList.filter(
        (item) =>
          item.status_id === "4" && item.department_id == selectedDepartment,
      )
    : leaveList;

  const handleChange = (value) => {
    setSelectedDepartment(value);
  };

  useEffect(() => {
    setSelectedDepartment(null);
  }, []);

  const viewLeave = (leaveObject, isViewOnly = false) => {
    toggleDisplayLeaveModal(true);
    setLeaveDetails({
      ...leaveObject,
      isViewOnly,
    });
  };

  const remindSuperior = (leaveRecord) => {
    const { confirm } = Modal;
    confirm({
      icon: "",
      closable: true,
      content:
        "Do you want to send reminder notification to HOD & Assistant HOD?",
      async onOk() {
        const { user_leave_id, user_id } = leaveRecord;
        const { code } = await CALL_API(
          "leave-notification-to-hod-assistant-hod",
          "post",
          {
            user_leave_id,
            user_id,
          },
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success(`Notification has been sent.`);
        } else {
          message.error(`Something went wrong. Please try again.`);
        }
      },
      onCancel() {},
    });
  };

  const CSVHeaders = [
    { label: "Employee ID" },
    { label: "Name" },
    { label: "Available Leaves" },
    { label: "Consumed Leaves" },
    { label: "Total Leaves" },
  ];
  const prepareCSV = async (event, done) => {
    if (userLeaves.length > 0) {
      setCSVDepartmentLeave(
        reduce(
          userLeaves?.filter((value) => {
            const available =
              value.data.find((item) => item.type === "available")?.value || 0;
            const consumed =
              value.data.find((item) => item.type === "consumed")?.value || 0;
            return available !== 0 || consumed !== 0;
          }),
          function (result, leave) {
            result.push({
              "Leave Category ID": leave.id,
              "Leave Category Name": leave.categoryName,
              "Available Leaves": leave.data[0].value,
              "Consumed Leaves": leave.data[1].value,
              // "Total Leaves": leave.data[0].value,
              CF: leave.data[0].carryforward,
            });
            return result;
          },
          [],
        ),
      );

      setTimeout(() => {
        csvLinkDepartment.current.link.click();
      });
    } else {
      console.log("No data available to download");
    }
  };

  return (
    <>
      <>
        <StyledRow gutter={16}>
          <Col md={24} sm={24} xs={24} xl={12}>
            <AttendanceBarChart isHrDashboard={true} />
          </Col>

          <Col md={24} sm={24} xs={24} xl={12}>
            <LocationBasedPresentStaff isHrDashboard={true} />
          </Col>
          {Menulist?.find(
            (item) =>
              item?.key === "allapprovals" &&
              item?.subMenu?.find(
                (subItem) =>
                  subItem?.key === "approvals" && subItem?.permission.view,
              ),
          ) && (
            <Col md={24} sm={24} xs={24} xl={24} ref={containerRef}>
              <StyledChartContainer>
                <div
                  className="chartstyle"
                  // style={{
                  //   display: "flex",
                  //   alignItems: "center",
                  //   justifyContent: "space-between",
                  //   marginBottom: "10px",
                  // }}
                >
                  <StyledTitle>
                    Waiting for Approval {`(${filterleavereport?.length})`}
                  </StyledTitle>
                  <StyledForm
                    form={form}
                    name="approval_form"
                    layout="inline"
                    initialValues={{
                      department_id: departmentOptions[0]?.value,
                    }}
                  >
                    <Select
                      className="select"
                      name="department_id"
                      placeholder={
                        <>
                          <img src={Filter} alt="filter" />{" "}
                          <span className="Status-placeholder">Department</span>
                        </>
                      }
                      options={departmentOptions}
                      onChange={handleChange}
                      value={selectedDepartment}
                      getPopupContainer={() => containerRef.current}
                    />
                  </StyledForm>
                </div>
                <Spin spinning={displayTaskLoader}>
                  <StyledTable
                    dataSource={filterleavereport}
                    columns={columns}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "" : "non-white"
                    }
                    onRow={(record) => {
                      return {
                        onClick: () => {
                          if (
                            Menulist?.find(
                              (item) =>
                                item?.key === "allapprovals" &&
                                item?.subMenu?.find(
                                  (subItem) =>
                                    subItem?.key === "approvals" &&
                                    subItem?.permission.edit,
                                ),
                            )
                          ) {
                            viewLeave(record, true);
                          }
                        },
                      };
                    }}
                    rowKey="user_leave_id"
                    pagination={
                      filterleavereport.length > 10 ? paginationOptions : false
                    }
                  />
                </Spin>
                <LeaveFormModel
                  isModalVisible={displayLeaveModal}
                  closeModal={() => toggleDisplayLeaveModal(false)}
                  userRoleId={userRoleId}
                  leaveDetails={leaveDetails}
                  toggleDisplayLeaveModal={toggleDisplayLeaveModal}
                  getLeaveList={getLeaveList}
                  setIsModalOpen={setIsModalOpen}
                  setLeaveID={setLeaveID}
                  sethavingCancel={sethavingCancel}
                  ClientId={ClientId}
                />
              </StyledChartContainer>
            </Col>
          )}
          <Col md={24} sm={24} xs={24} xl={24} className="mt-4">
            <Spin spinning={displayLeaveReportLoader}>
              <StyledLeaveRow gutter={24}>
                <Col span={12}>
                  <div>
                    <StyledTitle>Overall Department's Leave Report</StyledTitle>
                  </div>
                </Col>
                <Col
                  span={12}
                  className="leavereportstyle"
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  <ButtonOutlined
                    onClick={prepareCSV}
                    disabled={userLeaves.length === 0}
                  >
                    Export CSV file
                  </ButtonOutlined>
                  <CSVLink
                    header={CSVHeaders}
                    data={CSVDepartmentLeave}
                    filename={"Overall Leave Report.csv"}
                    asyncOnClick={true}
                    ref={csvLinkDepartment}
                  />
                </Col>
                {Array.isArray(leaveSummary) &&
                  leaveSummary
                    .filter((value) => {
                      const available =
                        value.data.find((item) => item.type === "available")
                          ?.value || 0;
                      const consumed =
                        value.data.find((item) => item.type === "consumed")
                          ?.value || 0;
                      return available !== 0 || consumed !== 0;
                    })
                    .map((value) => (
                      <Col
                        md={24}
                        sm={24}
                        xs={24}
                        xl={12}
                        key={value.categoryName}
                        onClick={() =>
                          openDetailWindow(value.categoryName, value.id)
                        }
                        className="mt-2"
                      >
                        <LeaveDonutChart
                          iconName={LEAVE_ICON[7]}
                          title={`${value.categoryName} - ${new Date()
                            .getFullYear()
                            .toString()}`}
                          data={value.data}
                          leaveId={value?.id}
                        />
                      </Col>
                    ))}
              </StyledLeaveRow>
            </Spin>
          </Col>
        </StyledRow>
      </>
      <Modal
        title="Approve leave"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to approve leave?</p>
      </Modal>

      <AllStaffLeaveBalance
        displayModal={staffDepartmentLeaveModal}
        toggleModal={() => toggleStaffDepartmentLeaveModal(false)}
        leaveTypeId={selectedLeaveTypeId}
        selectedDepartmentId={selectedDepartmentId}
        leaveName={selectedLeaveType}
        leaveList={leaveList}
        leaveCategoryList={leaveCategoryList}
        leaveCatgeory={leaveCatgeory}
        all={true}
        storeUserData={storeUserData}
        availableLeaves={availableLeaves}
      />
    </>
  );
}

export default HrDashboard;
